<template>
    <div class="contest responsive-height">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12" class="px-6">
                    <contest-tabs></contest-tabs>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import ContestTabs from '@/components/Contest/ContestTabs.vue';
export default {
    components: { ContestTabs },
}
</script>
